"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValueSorter = void 0;
const defaultValueSorter = (left, right, data) => {
    const getIndex = (id, data) => {
        let result = -1;
        data.some((i, index) => {
            if (i.id === id) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    };
    return getIndex(left, data) - getIndex(right, data);
};
exports.defaultValueSorter = defaultValueSorter;
//# sourceMappingURL=defaultValueSorter.js.map